import { Checkbox } from "@au-schein-de/au-ui-library";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useFiltersContext } from "../filters.context";
import { getTopProducerIds } from "../use-filters.hook";

export function TopProducersLowPriceFilter() {
	const { t } = useTranslation("product");
	const { filters, config, onFilterChange, onTopProducerWarning } =
		useFiltersContext();
	const value = filters.topProducersLowPrice ?? false;

	const labelFeatureFlagNamespace = ".withFeatureFlag";

	const onCheckedChange = useCallback(
		(checked: boolean) => {
			if (!checked && value) {
				onTopProducerWarning?.();
			}
			onFilterChange("topProducersLowPrice", checked || undefined);
			onFilterChange("producers", checked ? getTopProducerIds(config) : []);
		},
		[onFilterChange, config, value, onTopProducerWarning],
	);

	const handleContainerClick = useCallback(
		(e: React.MouseEvent<HTMLButtonElement>) => {
			if ((e.target as HTMLElement).closest('button[role="checkbox"]')) {
				return;
			}
			e.preventDefault();
			onCheckedChange(!value);
		},
		[onCheckedChange, value],
	);

	return (
		<button
			type="button"
			className="p-2.5 bg-info-100 rounded-xl h-9 flex items-center justify-center cursor-pointer [&_*]:cursor-pointer"
			onClick={handleContainerClick}
			aria-label={t(`filters${labelFeatureFlagNamespace}.topProducersLowPrice`)}
			aria-pressed={value}
			data-testid="top-producers-filter-container"
		>
			<Checkbox
				size="textSm"
				border="primary"
				label={t(`filters${labelFeatureFlagNamespace}.topProducersLowPrice`)}
				checked={value}
				onCheckedChange={onCheckedChange}
				data-testid="top-producers-filter"
				className="h-5 w-5"
			/>
		</button>
	);
}
